import {getDefaultLang, setCookie} from '../../utils/Utils'
export const CHANGE_LANG = 'kopaprolicense/app/changeLang'
const initialState = {   
    lang: getDefaultLang()
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
    case CHANGE_LANG:
        setCookie('lang', payload);
        return {
            ...state,
            lang: payload
        }

    default:
        return state
    }
}

export const changeLang = langCode => ({
    type: CHANGE_LANG,
    payload: langCode
})